// removed by extract-text-webpack-plugin
module.exports = {"block":"SpinnerBottom__block-1CzJ8","spinner":"SpinnerBottom__spinner-28-Mc"};